<template>
  <FieldWrapper class="af-field__input">
    <input
      v-model="inputValue"
      :placeholder="labelOrPlaceholder"
      :type="type"
      ref="field"
      :disabled="disabled"
    >
  </FieldWrapper>
</template>

<script>

import fieldMix from '../mixins/field';
import validationMix from '../mixins/validation';

import FieldWrapper from './internals/FieldWrapper';

export default {
  name: 'text-input',

  components: {
    FieldWrapper,
  },

  mixins: [
    fieldMix,
    validationMix,
  ],

  emits: ['update:modelValue', 'validated'],

  props: {
    min: {
      type: Number, 
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    }
  },

  computed: {
    regExp() {
      return this.min ? new RegExp('.{' + this.min + ',}') : /.*/
    }
  },

}
</script>


